import { useId, useState } from 'react';
import { MuteText } from '@elements/Common';
import { StyledButton } from '@elements/Button';
import { NumberMaskInput } from '@elements/CustomMaskInput';
import { MuteLabel } from '@elements/FormField';
import { CommonUtility } from '@utility/common';
import { BoldText } from './styles';

export function ChangeQuantity({ qty, maxQty, qtyChanged, closePopup }) {
  const [newQty, setNewQty] = useState(qty || '');
  const inputId = useId();
  return (
    <div className="sk:flex sk:min-h-[100px] sk:w-56 sk:flex-col sk:gap-3 sk:p-2">
      <BoldText>Shipping Quantity</BoldText>
      <div className="sk:flex sk:flex-col sk:gap-1">
        <MuteLabel htmlFor={inputId}>Quantity</MuteLabel>
        <NumberMaskInput
          id={inputId}
          maxValue={maxQty}
          minValue={1}
          value={newQty}
          onChange={setNewQty}
        />
        <MuteText>Max: {CommonUtility.numberWithCommas(maxQty)}</MuteText>
      </div>
      <StyledButton
        fluid
        type="submit"
        disabled={!newQty}
        onClick={() => {
          qtyChanged(+newQty);
          closePopup();
        }}
      >
        Confirm
      </StyledButton>
    </div>
  );
}
